export type TocItem = { id: string; text: string };

export const slugifyHeading = (value: string) =>
  value
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');

const stripTags = (html: string) =>
  html
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .trim();

export const processBlogContentHtml = (html: string) => {
  if (!html) return '';

  let out = html.replace(/<p[^>]*>(\s|&nbsp;|<br\s*\/?>)*<\/p>/gi, '');

  out = out.replace(/<br\s*\/?>(\s|&nbsp;)*<\/p>/gi, '</p>');

  out = out.replace(
    /<(h[2-4])([^>]*)>([\s\S]*?)<\/\1>/gi,
    (full, tag: string, attrs: string, inner: string) => {
      if (/\sid\s*=/.test(attrs)) return full;
      const text = stripTags(inner);
      if (!text) return full;
      return `<${tag}${attrs} id="${slugifyHeading(text)}">${inner}</${tag}>`;
    }
  );

  return out;
};

export const extractToc = (content?: string): TocItem[] => {
  if (!content) return [];

  const headings: Array<{ level: number; text: string }> = [];
  const regex = /<(h[2-4])[^>]*>([\s\S]*?)<\/\1>/gi;
  let match = regex.exec(content);

  while (match !== null) {
    const text = stripTags(match[2]);
    if (text)
      headings.push({ level: Number.parseInt(match[1].charAt(1), 10), text });
    match = regex.exec(content);
  }

  if (!headings.length) return [];

  const topLevel = Math.min(...headings.map(({ level }) => level));

  return headings
    .filter(({ level }) => level === topLevel)
    .map(({ text }) => ({ id: slugifyHeading(text), text }));
};
